import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import DesignCard from "./DesignCard";
import { useCatalog } from "../context/CatalogContext";

const PREVIEW_COUNT = 3;

export default function Collections() {
  const { categoriesMerged, getDesignsMerged, hideDefaults } = useCatalog();

  const previewFor = (cat) => {
    const list = [];
    for (const sub of cat.subCategories) {
      const designs = getDesignsMerged(cat.slug, sub.slug);
      if (designs.length) list.push(designs[0]);
      if (list.length >= PREVIEW_COUNT) break;
    }
    return list.slice(0, PREVIEW_COUNT);
  };

  const totalFor = (cat) => {
    if (hideDefaults) {
      return cat.subCategories.reduce(
        (n, s) => n + getDesignsMerged(cat.slug, s.slug).length,
        0
      );
    }
    return cat.subCategories.length * 54;
  };

  if (categoriesMerged.length === 0) {
    return (
      <section className="collections" id="collections">
        <div className="wrap">
          <div className="coll-head reveal">
            <div>
              <span className="eyebrow">Our Collections</span>
              <h2>Fresh designs are on the way.</h2>
            </div>
            <p>New pieces will appear here shortly.</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="collections" id="collections">
      <div className="wrap">
        <div className="coll-head reveal">
          <div>
            <span className="eyebrow">Our Collections</span>
            <h2>A piece for every celebration.</h2>
          </div>
          <p>
            Browse a small preview of each category below. Tap
            <strong> View all </strong> to see the full range, or search from the
            top-right for something specific.
          </p>
        </div>

        {categoriesMerged.map((cat, idx) => {
          const preview = previewFor(cat);
          if (preview.length === 0) return null;
          const total = totalFor(cat);
          return (
            <div
              className="cat-block reveal"
              key={cat.slug}
              style={{ animationDelay: `${idx * 60}ms` }}
            >
              <div className="cat-block-head">
                <div>
                  <span className="cat-block-eyebrow">{cat.label}</span>
                  <h3>{cat.tagline}</h3>
                  <p className="cat-block-meta">
                    {cat.subCategories.length} categories · {total}
                    {hideDefaults ? "" : "+"} designs
                  </p>
                </div>
                <Link
                  to={`/collections/${cat.slug}`}
                  className="cat-block-cta"
                >
                  View all {cat.label} designs <ArrowRight size={16} />
                </Link>
              </div>

              <div className="design-grid preview">
                {preview.map((d) => (
                  <DesignCard key={d.id} design={d} />
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
